import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  d305Api,
  QueryParams,
  StatRow,
  ProductStatRow,
  UnitSummary,
  VendorCount,
  VendorQueryResponse,
  ProductQueryResponse,
} from '../../../services/d305Api';

export function useD305Query() {
  const [loading, setLoading] = useState(false);
  const [vendorData, setVendorData] = useState<StatRow[]>([]);
  const [productData, setProductData] = useState<ProductStatRow[]>([]);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [groupCounts, setGroupCounts] = useState<VendorCount[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);
  const [currentType, setCurrentType] = useState<string>('vendor');

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d305Api.query(params);
      const type = params.report_type || 'vendor';
      setCurrentType(type);

      if (type === 'vendor_product') {
        const r = resp as ProductQueryResponse;
        if (r.data && r.data.length > 0) {
          setProductData(r.data);
          setVendorData([]);
          setUnitSummary(r.unit_summary || []);
          setGroupCounts(r.group_counts || []);
          setNoData(false);
        } else {
          setProductData([]);
          setVendorData([]);
          setUnitSummary([]);
          setGroupCounts([]);
          setNoData(true);
          message.info(r.message || '查無此資料!');
        }
      } else {
        const r = resp as VendorQueryResponse;
        if (r.data && r.data.length > 0) {
          setVendorData(r.data);
          setProductData([]);
          setUnitSummary(r.unit_summary || []);
          setGroupCounts(r.group_counts || []);
          setNoData(false);
        } else {
          setVendorData([]);
          setProductData([]);
          setUnitSummary([]);
          setGroupCounts([]);
          setNoData(true);
          message.info(r.message || '查無此資料!');
        }
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setVendorData([]);
    setProductData([]);
    setUnitSummary([]);
    setGroupCounts([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, vendorData, productData, unitSummary, groupCounts, queried, noData, currentType, runQuery, reset };
}
